/**
 * @title History Page - per tradein
 * @description Contains a list of historic tradeins
 */
import {HistoricTradeInFragment} from "../../../Queries";
import * as React from "react";
import {useRecoilValue} from "recoil";
import {LocalizationsAtom} from "../../../providers/localization/LocalizationProvider";
import {StyledDiv, StyledTypography} from "../../../providers/layout/LayoutProvider";
import {makeStyles} from "@mui/styles";
import {Box} from "@mui/material";
import {Thumbnails} from "../../../components/Thumbnails";
import {DateFormat} from "../../../utility/DateFormat";
import {useNavigate} from "react-router-dom";
import {TradeInPagePath} from "../tradein/TradeInPage";

type HistoryItemProps = {
   item: HistoricTradeInFragment
}

export const HistoryItem = ({item}: HistoryItemProps) => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const classes = useReturnItemStyles();
   const navigate = useNavigate();

   const images: string[] = [];
   for (const item1 of item.items) {
      if (item1.imageUrls?.[0]) {
         images.push(item1.imageUrls[0]);
      }
   }

   const onClick = () => {
      navigate(TradeInPagePath(item._id))
   }

   return <Box className={classes.frame} onClick={onClick}>
      <Thumbnails imageUrls={images} size={90}/>
      <Box sx={{margin: '5px', display: 'flex', flexDirection: 'column', gap: '10px'}}>
         <StyledDiv type={"main"} sx={{display: 'flex', flexDirection: 'column'}}>
            <Box>
               <StyledTypography type={"main"} variant={"body1"}>
                  {localizations.historicPageTradeInPrefix} {DateFormat.toReadable(item.dateTime)}
               </StyledTypography>
            </Box>
            <Box>
               <StyledTypography type={"main"} variant={"body1"} sx={{
                  fontSize: '80%',
                  opacity: '50%'
               }}>
                  {item?.registered && <>{localizations.historicPageTradeInReceived}</>}
                  {!item?.registered && <>{localizations.historicPageTradeInNotReceived}</>}
               </StyledTypography>
            </Box>
         </StyledDiv>
         <Box>{item?.vouchers?.map(voucher => {
            return <StyledDiv type={"main"}>
               <StyledTypography type={"main"} variant={"body1"}>
                  {localizations.historicPageTradeInVoucher} {voucher?.code}
               </StyledTypography>
               <StyledTypography type={"main"} variant={"body1"}>
                  {localizations.historicPageTradeInValue} {Math.round(voucher?.currentValue || 0)} {voucher?.currency}
               </StyledTypography>
            </StyledDiv>
         })}</Box>
      </Box>
   </Box>
}


const useReturnItemStyles = makeStyles({
   frame: {
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
      alignItems: "top",
      borderTop: '1px solid #e0e0e0',
      padding: '20px',
      cursor: 'pointer'
   },
});
